import { BinaryTreeNode } from './binary-tree-node';
import { CoordinatorService } from './coordinator.service';
import { ScriptBase } from './script-base';
import { ScriptDataset } from './script-dataset';
import { ScriptHitset } from './script-hitset';
import { ScriptKeyword } from './script-keyword';
import { SELECTION_ROLE } from './script-types';

type _FIRST_ARG = ScriptHitset | ScriptKeyword | ScriptDataset;
type FIRST_ARG = _FIRST_ARG; // | _FIRST_ARG[]

export class ScriptNode extends ScriptBase {
    #coords: CoordinatorService;
    #_node: BinaryTreeNode;

    constructor(coords: CoordinatorService, _node: BinaryTreeNode) {
        super(coords, _node);
        this.#coords = coords;
        this.#_node = _node;
    }

    private _newHitset(x: Exclude<FIRST_ARG, ScriptHitset>) {
        if (typeof x === 'string') {
            return this.#coords.script$.dataset().search(x);
        } else return x.hitset();
    }

    log() {
        console.log(
            'Node:',
            this.#_node.id,
            'TITLE:',
            this.#_node.title,
            'DESCRIPTION:',
            this.#_node.description,
        );
    }

    isOn(xitemId: string) {
        return this.#_node.isOn(xitemId);
    }

    setIsOn(xitemId: string, isOn: boolean) {
        this.#_node.setIsOn(xitemId, isOn);
    }

    get childLs() {
        return this.#_node.childLs.map((x) => x.scriptClass);
    }

    hitset(isPreview = false, userIdLs?: string[]) {

        const nH = new ScriptHitset(this.#coords, isPreview);
               const s = this.#_node.selectedIdSet(userIdLs);
        return this._hitset(nH, s);
    }

    add = this.select;
    select(h: FIRST_ARG) {
        if (!(h instanceof ScriptHitset)) h = this._newHitset(h);
        this.#_node.addIds(h.idSet);
        return this;
    }

    remove = this.unselect;
    unselect(h: FIRST_ARG) {
        if (!(h instanceof ScriptHitset)) h = this._newHitset(h);
        this.#_node.deleteIds(h.idSet);
        return this;
    }

    delete(withItems = false) {
        if (withItems === true || this.hitset().size === 0) this.#_node.delete();
    }

    get title() {
        return this.#_node.title;
    }

    set title(value: string) {
        this.#_node.title = value;
    }

    children() {
        return this.#_node.childLs.map((x) => x.scriptClass);
    }

    node(path: string, isCreate = false) {
        const nd = this.#_node.getNodeFromPath(path, isCreate);
        if (nd) return nd.scriptClass;
        else return null;
    }

    get idSet() {
        return this.hitset().idSet;
    }

    get container() {
        return this.#_node.binaryTree.scriptClass;
    }
}
